import {createRef, RefObject} from 'react';
import {Footer} from './components/MacroFooter/MacroFooter';

export const macroFooterRef: RefObject<Footer> = createRef();
